<template>
  <div class="pt-2 pl-3 ma-2">
    <div v-if="userData && userData.OfficeId">
      <img :src="logoUrl" />
      <div class="text-h6">
        {{ userData.OfficeName }}
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue'
import { userData } from '@/store/UserSession'
import FieldService from '@/services/FieldService'

export default {
  name: 'Banner',
  setup() {
    const logoUrl = ref()

    watch(
      () => userData.value.OfficeId,
      () => {
        let tenantId = FieldService.getTenantId()
        let url = `${FieldService.apiURL}/Office/Logo?tenant-id=${tenantId}&officeId=${userData.value.OfficeId}`
        logoUrl.value = url
      }
    )

    return { userData, logoUrl }
  }
}
</script>
<style lang="scss" scoped>
.office-name {
  font-weight: 400;
  font-size: 1.5em;
}
</style>
